<app-panel-header-image-view pretitle="{{'Officials' | transloco}}" title="{{'Search' | transloco}}" banner_image="../../../../modules/custom/wa_angular/app/assets/images/officials-headers.jpg"></app-panel-header-image-view>

<app-app-content-page-wrapper>
<lib-filters-component  [filters_options]="filter_service.filtersType"></lib-filters-component>
<app-wa-table [customMsgBox]="customBox" [showNoResultsMessageCondition]="ShowNoResultsBox" [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
  <app-search-box-table #customBox [subtitle]="'search_officials' | transloco">

  </app-search-box-table>
  <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-athlete>
                <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>

  </ng-template>
  <ng-template  app-column let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
  </ng-template>
  <ng-template  [extraClass]="[]" app-column let-athlete>
    <lib-country-flag [name]="getCountryName(athlete.EntryMA)" [id]="athlete.EntryMA"> </lib-country-flag>
  </ng-template>
  <ng-template  [extraClass]="[]" app-column let-athlete>

    <ng-container>
      <div [innerHTML]="getAllPositions(athlete)"></div>
    </ng-container>

  </ng-template>
  <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column-responsive let-athlete>
    <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>
  </ng-template>
  <ng-template  app-column-responsive let-athlete>
    <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
    <div class="inner-info">
      <div><p class="uppertext-black">{{'Country' | transloco}}:          </p>  <lib-country-flag [name]="getCountryName(athlete.EntryMA)" [id]="athlete.EntryMA"> </lib-country-flag>   </div>
     <div><p class="uppertext-black">{{'wa_positions' | transloco}}:          </p>

          <ng-container>
              <div [innerHTML]="getAllPositions(athlete)"></div>
            </ng-container>
          </div></div>
  </ng-template>

</app-wa-table>
<app-news-panel [news]="news" *ngIf="news && news.length > 0" [title]="'related_news' | transloco" ></app-news-panel>
</app-app-content-page-wrapper>

